import { render, staticRenderFns } from "./qimenresult.vue?vue&type=template&id=23326194&scoped=true"
import script from "./qimenresult.vue?vue&type=script&lang=js"
export * from "./qimenresult.vue?vue&type=script&lang=js"
import style0 from "./qimenresult.vue?vue&type=style&index=0&id=23326194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23326194",
  null
  
)

export default component.exports